module.exports = __webpack_public_path__ + "img/folder.31111679.svg";